import React from 'react';
import Collapse from '@material-ui/core/Collapse';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import { formatAgreementTypeName, getOwnersStringForAgreementGroupByType } from '../HubUtils';
import './TaxAwareness.scss';

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    signDisplay: 'always',
});

const determineFundName = (agr) => {
    if (agr.productTypeId === 20) {
        return "Brokerage";
    }
    if (agr.productTypeId === 110) {
        return "Active Plus Portfolio";
    }
    return agr.holdings[0].fundName;
};

const determineFundTicker = (agr) =>
    (agr.productTypeId === 20 || agr.productTypeId === 110) ? "" : agr.holdings[0].ticker;

function Row(props) {
    const { row } = props;
    const regLineMaxWidth = window && window.innerWidth < 960 ? Math.round(window.innerWidth * (1/2)) : 300;

    return (
        <>
            <TableRow className="taxAwarenessTableShadedRow">
                <TableCell>
                    <Typography className='agreement-type-name' id={`agr-type-name-tax-${row.agreementTypeId}`} style={{ maxWidth: `${regLineMaxWidth}px` }}>
                        {row.agreementTypeId === 11 ?
                            <span className='blocked_data'>
                                {`${row.agreementTypeName.toUpperCase()}${row.registrationLines.reduce((agg, regLine) => `${agg} ${regLine}`, "").slice(0, 100)}`}
                            </span>
                            :
                            formatAgreementTypeName(row)
                        }
                    </Typography>
                    <Typography className='agreement-owner blocked_data' id={`agr-owner-tax-${row.agreementTypeId}`}>
                        {getOwnersStringForAgreementGroupByType(row)}
                        {row.deceasedOwner && row.deceasedOwner.length ? `, ${row.deceasedOwner} (DCD)` : ''}
                        {row.powerOfAttorney && row.powerOfAttorney.length ? `, ${row.powerOfAttorney} (Agent)` : ''}
                    </Typography>
                </TableCell>
                <TableCell />
            </TableRow>
            <TableRow>
                <TableCell style={{ padding: 0 }} colSpan={12}>
                    <Collapse in timeout="auto" unmountOnExit>
                        <Table>
                            <TableBody>
                                {row.agreements.map((agreement) => (
                                    <TableRow key={agreement.agreementId}>
                                        <TableCell style={{ paddingLeft: 16 }} align="left" id={`tax-agr-info-${agreement.agreementId}`}>
                                            <Typography display="inline" className="agreement-fund-name" id={`agr-fund-name-tax-${agreement.agreementId}`}>
                                                {determineFundName(agreement, row.productTypeId)}
                                            </Typography>
                                            <Typography display="inline" className='tax-ticker' id={`tax-ticker-${agreement.agreementId}`}>
                                                { determineFundTicker(agreement, row.productTypeId) }
                                            </Typography>

                                            <Typography className='agreement-number blocked_data' id={`agr-num-tax-${agreement.agreementId}`}>
                                                {agreement.agreementNumber}{agreement.checkSum ? `-${agreement.checkSum}` : null}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="right" id={`gain-loss-cell-${agreement.agreementId}`}>
                                            <Typography className='gain-loss' id={`gain-loss-${agreement.agreementId}`}>
                                                {!agreement.costBasis ||
                                                (agreement.costBasis.coveredAvailableCostAmount === 0.0 && agreement.costBasis.coveredMarketValue !== 0.0) ||
                                                (agreement.costBasis.nonCoveredAvailableCostAmount === 0.0 && agreement.costBasis.nonCoveredMarketValue !== 0.0) ?
                                                    'Unavailable' :
                                                    formatter.format(agreement.costBasis.unrealizedTotalGainLoss)}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}
 /* eslint-disable react/no-array-index-key */
const TaxAwareness = ({ agreementsGroupByType }) => (
    <TableContainer component={Paper}>
        <Table className="taxAwarenessTable" aria-label="collapsible table">
            <TableHead>
                <TableRow style={{ backgroundColor: '#1E2D39' }}>
                    <TableCell align="left">
                        <Typography className='table-header'>
                            CURRENT ACCOUNT(S)
                        </Typography>
                    </TableCell>
                    <TableCell align="right">
                        <Typography className='table-header'>
                            TOTAL UNREALIZED GAIN / LOSS
                        </Typography>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {agreementsGroupByType.filter(agrGroupByType => agrGroupByType.taxableAccount && agrGroupByType.agreements && agrGroupByType.agreements.length > 0).map((
                    agrGroupByType, index) => ( <Row key={index} row={agrGroupByType} />
                ))}
            </TableBody>
        </Table>
    </TableContainer>
);

export default TaxAwareness;
